/// <amd-module name="Wiki/Overview/Utils/UrlHelper" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssLocationService } from "VSS/Platform/Location";

export const c_vcPreviewModeActionId = "preview";

export function openUrlInNewTab(url: string): void {
    const windowObject = window.open(url, "_blank");
    windowObject && (windowObject.opener = null);
}

export function getExplorerUrl(
    pageContext: IVssPageContext,
    project: string,
    repository: string,
    path?: string,
    action?: string,
    routeData?: any
): string {
    const routeId = "ms.vss-code-web.files-route-git";

    if (!routeData) {
        routeData = {};
    }
    if (action) {
        routeData._a = action;
    }
    if (path) {
        routeData.path = path;
    }

    routeData["project"] = project;
    routeData["vc.GitRepositoryName"] = repository;

    return pageContext.getService<IVssLocationService>("IVssLocationService").routeUrl(routeId, routeData);
}
